import {
  RECENT_USER_ITEM_HEIGHT,
  RecentUserItemSkeleton,
} from '$common/recent-user-item/recent-user-item-skeleton'
import { FORWARD_MENU_DEFAULT_HEIGHT } from '$comp/modals/forward-menu/forward-menu'
import { ForwardMenuItemsWrapper } from '$comp/modals/forward-menu/components/forward-menu-item-wrapper/forward-menu-item-wrapper'

export function ForwardMenuSkeleton({ height }: { height: number }) {
  const skeletonCount = Math.round(
    ((height || FORWARD_MENU_DEFAULT_HEIGHT) / RECENT_USER_ITEM_HEIGHT) * 4,
  )
  return (
    <ForwardMenuItemsWrapper>
      {Array(skeletonCount)
        .fill(null)
        .map(() => (
          <RecentUserItemSkeleton />
        ))}
    </ForwardMenuItemsWrapper>
  )
}
